// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton, LinearProgress,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminOtherStateCourtComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedJudgement, setSelectedJudgement] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: '',
//     order_no: '',
//     order_date: '',
//     language: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteJudgement, setDeleteJudgement] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
//     { id: 'orderNo', field: 'orderNo', headerName: 'Order Number', width: 150 },
//     { id: 'orderDate', field: 'orderDate', headerName: 'Order Date', width: 150 },
//     { id: 'language', field: 'language', headerName: 'Language', width: 150 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             Download
//           </a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchJudgements();
//   }, []);

//   const fetchJudgements = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/other-state-court-orders/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           orderNo: item.order_no,
//           orderDate: item.order_date,
//           language: item.language,
//           links: item.link || '',
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch other state Court Orders:', error);
//         setSnackbarMessage('Failed to load other state Court Orders.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddJudgement = () => {
//     setIsEditMode(false);
//     setFormData({ subject: '', order_no: '', order_date: '', language: '' });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (judgement) => {
//     setIsEditMode(true);
//     setSelectedJudgement(judgement);
//     setFormData({
//       subject: judgement.subject,
//       order_no: judgement.orderNo,
//       order_date: judgement.orderDate,
//       language: judgement.language,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (judgement) => {
//     setDeleteJudgement(judgement);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/other-state-court-ordes/${deleteJudgement.id}/`)
//       .then(() => {
//         setSnackbarMessage('other state Court Orders deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchJudgements();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete other state Court Orders!.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteJudgement(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = 'Subject is required';
//     if (!formData.order_no?.trim()) errors.order_no = 'Order Number is required';
//     if (!formData.order_date) errors.order_date = 'Order Date is required';
//     if (!formData.language?.trim()) errors.language = 'Language is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('subject', formData.subject);
//     form.append('order_no', formData.order_no);
//     form.append('order_date', formData.order_date);
//     form.append('language', formData.language);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(`${API_BASE_URL}/home-notification/other-state-court-orders/${selectedJudgement.id}/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('other state Court Orders updated successfully.');
//       } else {
//         await api.post(`${API_BASE_URL}/home-notification/other-state-court-orders/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('other state Court Orders added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchJudgements();
//       setOpenFormDialog(false);
//     } catch (error) {
//       console.error('Submit failed:', error);
//       setSnackbarMessage('Failed to submit other state Court Orders.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', backgroundColor: '#fff' }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" fontWeight="bold">
//           Other State Court Orders
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddJudgement} disabled={uploading}>
//           Add Judgement
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Other state Court Orders' : 'Add Other State Court Orders'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Subject"
//             fullWidth
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Order Number"
//             fullWidth
//             value={formData.order_no}
//             error={!!formErrors.order_no}
//             helperText={formErrors.order_no}
//             onChange={(e) => setFormData({ ...formData, order_no: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Order Date"
//             type="date"
//             fullWidth
//             value={formData.order_date}
//             error={!!formErrors.order_date}
//             helperText={formErrors.order_date}
//             onChange={(e) => setFormData({ ...formData, order_date: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Language"
//             fullWidth
//             value={formData.language}
//             error={!!formErrors.language}
//             helperText={formErrors.language}
//             onChange={(e) => setFormData({ ...formData, language: e.target.value })}
//             disabled={uploading}
//           />
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: 8 }}
//               type="file"
//               onChange={handleFileChange}
//               disabled={uploading}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error" sx={{ mt: 1 }}>
//                 {formErrors.file}
//               </Typography>
//             )}
//             {isEditMode && !selectedFile && selectedJudgement?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedJudgement.links}`} target="_blank" rel="noopener noreferrer">
//                   Download
//                 </a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
//             {isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this Other State Court Order?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  LinearProgress,
  CircularProgress
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminOtherStateCourtComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedJudgement, setSelectedJudgement] = useState(null);

  const [formData, setFormData] = useState({
    subject: '',
    order_no: '',
    order_date: '',
    language: '',
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteJudgement, setDeleteJudgement] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
    { id: 'orderNo', field: 'orderNo', headerName: 'Order Number', width: 150 },
    { id: 'orderDate', field: 'orderDate', headerName: 'Order Date', width: 150 },
    { id: 'language', field: 'language', headerName: 'Language', width: 150 },
    {
      id: 'links',
      field: 'links',
      headerName: 'Links',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            Download
          </a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchJudgements();
  }, []);

  const fetchJudgements = () => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/home-notification/other-state-court-orders/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          subject: item.subject,
          orderNo: item.order_no,
          orderDate: item.order_date,
          language: item.language,
          links: item.link || '',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch other state Court Orders:', error);
        setSnackbarMessage('Failed to load other state Court Orders.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddJudgement = () => {
    setIsEditMode(false);
    setFormData({ subject: '', order_no: '', order_date: '', language: '' });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (judgement) => {
    setIsEditMode(true);
    setSelectedJudgement(judgement);
    setFormData({
      subject: judgement.subject,
      order_no: judgement.orderNo,
      order_date: judgement.orderDate,
      language: judgement.language,
    });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (judgement) => {
    setDeleteJudgement(judgement);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api
      .delete(`/home-notification/other-state-court-orders/${deleteJudgement.id}/`)
      .then(() => {
        setSnackbarMessage('Other state Court Orders deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchJudgements();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete other state Court Orders.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteJudgement(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = 'Subject is required';
    if (!formData.order_no?.trim()) errors.order_no = 'Order Number is required';
    if (!formData.order_date) errors.order_date = 'Order Date is required';
    if (!formData.language?.trim()) errors.language = 'Language is required';
    if (!selectedFile && !isEditMode) errors.file = 'File is required';
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors((prev) => ({ ...prev, file: null }));
      setSelectedFile(file);
    }
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('subject', formData.subject);
    form.append('order_no', formData.order_no);
    form.append('order_date', formData.order_date);
    form.append('language', formData.language);
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);
      if (isEditMode) {
        await api.patch(`/home-notification/other-state-court-orders/${selectedJudgement.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Other state Court Orders updated successfully.');
      } else {
        await api.post(`/home-notification/other-state-court-orders/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Other state Court Orders added successfully.');
      }
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchJudgements();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit other state Court Orders.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" fontWeight="bold">Other State Court Orders</Typography>
        <Button variant="contained" color="primary" onClick={handleAddJudgement} disabled={uploading}>Add Judgement</Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Other State Court Orders' : 'Add Other State Court Orders'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Order Number"
            fullWidth
            value={formData.order_no}
            error={!!formErrors.order_no}
            helperText={formErrors.order_no}
            onChange={(e) => setFormData({ ...formData, order_no: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Order Date"
            type="date"
            fullWidth
            value={formData.order_date}
            error={!!formErrors.order_date}
            helperText={formErrors.order_date}
            onChange={(e) => setFormData({ ...formData, order_date: e.target.value })}
            InputLabelProps={{ shrink: true }}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Language"
            fullWidth
            value={formData.language}
            error={!!formErrors.language}
            helperText={formErrors.language}
            onChange={(e) => setFormData({ ...formData, language: e.target.value })}
            disabled={uploading}
          />
          <Box mt={2}>
            <input
              accept="*"
              style={{ display: 'block', marginTop: 8 }}
              type="file"
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedJudgement?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={`${API_BASE_URL}${selectedJudgement.links}`} target="_blank" rel="noopener noreferrer">
                  Download
                </a>
              </Typography>
            )}
          </Box>
          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>Cancel</Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
            {uploading ? <CircularProgress size={24} color="inherit" /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this Other State Court Order?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>Delete</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
